import React from 'react';
import { PhotoIcon } from '@heroicons/react/20/solid';

import ModalContent from './content';

interface ComponentProps {
  visible: boolean;
  title?: string;
  imageSrc?: string | null;
  imageAlt?: string;
  onClose: () => void;
}

function PhotoPreviewModal({ visible, title, imageSrc, imageAlt, onClose }: ComponentProps) {
  const altText = imageAlt || title || 'Photo preview';

  return (
    <ModalContent visible={visible} onCloseClick={onClose} title={title} wide>
      <div className="flex h-[80vh] items-center justify-center px-3">
        {imageSrc ? (
          <img alt={altText} src={imageSrc} className="object-contain mx-auto max-w-full max-h-full" />
        ) : (
          <PhotoIcon className="text-gray-300" width={60} height={60} />
        )}
      </div>
    </ModalContent>
  );
}

PhotoPreviewModal.defaultProps = {
  title: '',
  imageSrc: null,
  imageAlt: '',
};

export default PhotoPreviewModal;
